import { useSearchParams } from "react-router-dom";

export const useSearchParamsOfBooking = () => {
  const [searchParams] = useSearchParams();
  const bookingId = (searchParams.get("bookingId") ?? "").toString();
  const editBookingId = (searchParams.get("editBookingId") ?? "").toString();
  const isEdit = searchParams.get("isEdit") === "true" ? true : undefined;
  const isUpgrade = searchParams.get("isUpgrade") === "true" ? true : undefined;
  return {
    bookingId,
    editBookingId,
    isEdit,
    isUpgrade,
  };
};
